import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import FontAwesome from 'react-fontawesome';

import VisibilitySensor from 'react-visibility-sensor';
import { getFileUrl } from '../../util/file';

export default class FileLoad extends Component {
    constructor(props) {
        super(props);

        this.state = {
            url: props.url,
            isLoading: false,
            isLoaded: !!props.url,
            loadedUrls: {},
        };
    }

    componentDidMount() {
        if(this.props.loadonmount) {
            this.handleLoadFile();
        }
    }

    componentDidUpdate(prevProps, prevState) {
        if(prevProps.filename !== this.props.filename) {
            this.handleLoadFile();
        }
    }

    handleVisibilityChange = isVisible => {
        if(isVisible && !this.state.isLoaded && !this.state.isLoading) {
            this.handleLoadFile();
        }
    };

    handleLoadFile = () => {
        if(this.props.filename) {
            if(this.state.loadedUrls[this.props.filename]) {
                this.setState({
                    url: this.state.loadedUrls[this.props.filename],
                    isLoaded: true,
                });
			} else {
                this.setState({
                    isLoading: true,
                });
                getFileUrl(this.props.filename, this.props.owner, 'get', this.props.isPublic, this.props.isPublic && { k: this.props.fileKey, s: this.props.fileSalt }).then(url => {
                    // console.log(url);
                    this.setState({
                        url,
                        isLoading: false,
                        isLoaded: true,
                        loadedUrls: {
                            ...this.state.loadedUrls,
                            [this.props.filename]: url,
                        },
                    });
                }).catch(() => {
                    console.error('File not found !');
                    this.setState({
                        isLoading: false,
                    });
                });
            }
        }
    };

	renderDownloadButton() {
		return <a href={this.state.url} download={this.props.filename.split('/').pop()} target="_blank"><FontAwesome name="download" /> {this.props.filename.split('/').pop()}</a>; // eslint-disable-line
	}

    renderFileTag() {
        if(this.props.filename) {
            const ext = this.props.filename.split('.').pop();
			let mime = null;
            switch(ext.toLowerCase()) {
                case 'jpg':
                case 'jpeg':
                case 'gif':
                case 'png':
                case 'tiff':
                case 'bmp':
                case 'svg':
                case 'webp':
                    return <img src={this.state.url} {...this.props} />; // eslint-disable-line

				case 'mov':
					mime = 'video/quicktime';

                case 'mp4': // eslint-disable-line
                case 'ogv':
                case 'webm':
                    return (
						<Fragment>
							<video controls width="100%" {...this.props}>
								<source src={this.state.url} type={mime || `video/${ext}`} />
								Sorry, your browser doesn't support embedded videos.
							</video>
							{this.props.allowDownload && this.renderDownloadButton()}
						</Fragment>
                    );

                case 'mp3':
                case 'opus':
                    return (
						<Fragment>
							<audio controls src={this.state.url} {...this.props}>
								Your browser does not support the <code>audio</code> element.
							</audio>
							{this.props.allowDownload && this.renderDownloadButton()}
						</Fragment>
                    );

                default:
                    return this.renderDownloadButton();
            }
        }
    }

    render() {
        if(this.props.filename) {
            return (
                <VisibilitySensor onChange={this.handleVisibilityChange}>
					{
						this.state.isLoaded
						? this.renderFileTag()
						: this.state.isLoading
							? <FontAwesome name="spinner" spin className="display-1 m-3" />
							: <FontAwesome name="file-image" className="display-1 m-3" />
					}
                </VisibilitySensor>
            );
        }
        return null;
    }
}

FileLoad.propTypes = {
    filename: PropTypes.string,
    owner: PropTypes.string,
    loadonmount: PropTypes.bool,
    url: PropTypes.string,
	allowDownload: PropTypes.bool,
	isPublic: PropTypes.bool,
	fileKey: PropTypes.string,
	fileSalt: PropTypes.string,
};
